<template>
    <el-dialog title="包材提交" :visible.sync="dialogTableVisible" width="40%">
        <el-form :model="formData" ref="formData" label-width="100px" :rules="rulesFormData">
            <el-form-item label="包材名称：" prop="packagingName">
                <el-input placeholder="请输入" v-model="formData.packagingName" :readonly="isEdit"></el-input>
            </el-form-item>
            <el-form-item label="包材数量：" prop="packagingCount">
                <el-input placeholder="请输入" v-model="formData.packagingCount" :readonly="isEdit"></el-input>
            </el-form-item>
            <el-form-item label="申报金额：" prop="charge">
                <el-input placeholder="请输入" v-model="formData.charge" :readonly="isEdit">
                    <template slot="append">
                        CNY
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="说明：" prop="description">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="请输入内容"
                    v-model="formData.description"
                    :readonly="isEdit"
                ></el-input>
            </el-form-item>
        </el-form>
        <div class="image-list">
            <li class="list-group-item" v-for="(element, index) in formData.imageList" :key="element">
                <div class="mask">
                    <i class="custom-icon el-icon-zoom-in" @click="handlePictureCardPreview(element)"></i>
                    <i class="custom-icon el-icon-delete" v-if="!isEdit" @click="handleRemoveSelect(index)"></i>
                </div>

                <div class="badge">
                    <img :src="element" alt />
                </div>
            </li>
            <el-upload
                v-if="!isEdit"
                :action="action"
                list-type="picture-card"
                :on-success="handleAvatarSuccess"
                :headers="customHeaders"
                :show-file-list="false"
                multiple
            >
                <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
        </div>
        <div slot="footer" class="dialog-footer" v-if="!isEdit">
            <el-button @click="dialogTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="onSubmit" :loading="subloading">提 交</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { Baseurl } from "@/api/api/api";

export default {
    name: "Plpackingmaterials",
    data() {
        return {
            action: Baseurl + "imageController/uploadImage",
            dialogTableVisible: false,
            subloading:false,
            formData: {
                packagingName: "",
                packagingCount: "",
                imageList: [],
                description: "",
                charge: "",
            },
            rulesFormData: {
                packagingName: [{ required: true, message: "包材名称输入有误", trigger: "blur" }],
                packagingCount: [{ required: true, message: "包材数量输入有误", trigger: "blur" }],
                description: [{ required: true, message: "说明输入有误", trigger: "blur" }],
                charge: [{ required: true, message: "申报金额输入有误", trigger: "blur" }],
            },
            itemData: {},
            dialogImageUrl: "",
            dialogVisible: false,
            customHeaders: { token: localStorage.getItem("token") },
        };
    },
    computed: {
        isEdit() {
            return this.itemData.status === 1;
        },
    },
    methods: {
        init(data) {
            this.dialogTableVisible = true;
            this.subloading = false;
            const data2 = JSON.parse(JSON.stringify(data));
            if (Object.keys(data2).length) {
                this.itemData = data2;
                let { packagingName, packagingCount, imageList, description, charge } = this.itemData;
                if (!imageList) imageList = [];
                if (!description) description = "";
                if (!charge) charge = "";
                this.formData = {
                    packagingName,
                    packagingCount,
                    imageList,
                    description,
                    charge,
                };
                return
            }
            this.$nextTick(() => {
                this.$refs.formData.resetFields();
            });
        },
        close() {
            this.dialogTableVisible = false;
        },
        handleRemove(index) {
            this.formData.imageList.splice(index, 1);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file;
            this.dialogVisible = true;
        },
        handleAvatarSuccess(response, file, fileList) {
            this.formData.imageList.push(response.data);
        },
        onSubmit() {
            this.subloading = true
            this.$refs.formData.validate(valid => {
                if (!valid) return;
                if (!this.formData.imageList.length) {
                    this.$message.warning("请上传图片");
                    return;
                }
                this.$emit("confirm", this.formData);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.line-height {
    line-height: 40px;
}
.image-list {
    display: flex;
    flex-wrap: wrap;

    .list-group-item {
        width: 148px;
        height: 148px;
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
        margin-right: 10px;
        margin-bottom: 10px;
        // float: left;
        position: relative;
        overflow: hidden;
        .mask {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            transition-duration: 0.5s;
            .custom-icon {
                font-size: 20px;
                margin: 0 8px;
                color: #fff;
            }
        }
        &:hover .mask {
            opacity: 1;
            border-color: #409eff;
        }
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
